import { render } from "./HelpMessage.vue.ts?vue&type=template&id=773baa80&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./HelpMessage.vue?vue&type=template&id=773baa80&ts=true"
import script from "./HelpMessage.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./HelpMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpMessage.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./HelpMessage.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/merchant3/components/HelpMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "773baa80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('773baa80', __exports__)) {
    api.reload('773baa80', __exports__)
  }
  
  module.hot.accept("./HelpMessage.vue.ts?vue&type=template&id=773baa80&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./HelpMessage.vue?vue&type=template&id=773baa80&ts=true", () => {
    api.rerender('773baa80', render)
  })

}


export default __exports__